import { render, staticRenderFns } from "./button-atras.vue?vue&type=template&id=3f27fcc8&scoped=true"
import script from "./button-atras.vue?vue&type=script&lang=js"
export * from "./button-atras.vue?vue&type=script&lang=js"
import style0 from "./button-atras.vue?vue&type=style&index=0&id=3f27fcc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f27fcc8",
  null
  
)

export default component.exports